import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { Mic, TextFields } from '@mui/icons-material';

interface SpeechToTextIconProps {
  fontSize?: 'small' | 'medium' | 'large';
  sx?: SxProps<Theme>;
}

/**
 * Icon combining microphone and text symbol to represent speech-to-text conversion
 */
export const SpeechToTextIcon: React.FC<SpeechToTextIconProps> = ({ fontSize = 'small', sx }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: fontSize === 'small' ? 20 : fontSize === 'medium' ? 24 : 28,
        height: fontSize === 'small' ? 20 : fontSize === 'medium' ? 24 : 28,
        ...sx
      }}
    >
      <Mic fontSize={fontSize} />
      <TextFields
        fontSize="inherit"
        sx={{
          position: 'absolute',
          right: -4,
          bottom: -4,
          fontSize: fontSize === 'small' ? '0.6em' : '0.65em',
          backgroundColor: 'background.paper',
          borderRadius: '50%',
          padding: '1px'
        }}
      />
    </Box>
  );
};

export default SpeechToTextIcon;
